export enum BaseStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum ItemStatusEnum {
  Ready = 'Ready',
  InProduction = 'InProduction',
  Delivered = 'Delivered',
  OnHold = 'OnHold',
  Canceled = 'Canceled',
}

export enum SubcontractorStatusEnum {
  InProgress = 'InProgress',
  Released = 'Released',
  Done = 'Done',
  Pending = 'Pending',
  NA = 'NA',
}

export enum UserType {
  Office = 'Office',
  Subcontractor = 'Subcontractor',
  Production = 'Production',
  Engineering = 'Engineering',
  ProcessWorker = 'ProcessWorker',
}

export enum EngineeringTeamType {
  Team = 'team',
  Classification = 'classification',
}

export enum SubcontractorType {
  All = 'all',
  LaserCutting = 'laser-cutting',
  InsulationCutting = 'insulation-cutting',
  RollForming = 'roll-forming',
  Folding = 'folding',
}

export enum URLParamsKey {
  Id = 'id',
  Modal = 'modal',
  Delete = 'delete',
  ChangePassword = 'changePassword',
  ViewDetail = 'viewDetail',
  OrderKey = 'orderKey',
  OrderValue = 'orderValue',
  Page = 'page',
  PageSize = 'pageSize',
  SearchText = 'searchText',
  Status = 'status',
  Username = 'username',
  FromDate = 'fromDate',
  ToDate = 'toDate',
  Transfer = 'transfer',
  ReleaseToId = 'releaseToId',
  ReleaseToName = 'releaseToName',
  TeamId = 'teamId',
  CompanyId = 'companyId',
  Stage = 'stage',
  Refresh = 'refresh',
  showAllFiles = 'showAllFiles',
  screenCycleTime = 'screenCycleTime',
  Tab = 'tab',
  dateFilterType = 'dateFilterType',
  hasListener = 'hasListener',
  isSelf = 'isSelf',
  tableSelect = 'tableSelect',
}

export enum URLParamsValue {
  Modal = 'SM',
  Delete = 'SD',
  ChangePassword = 'CP',
  ViewDetail = 'VD',
  DataEntryCheck = 'DEC',
  DataEntryInput = 'DEI',
}

export enum JobColorEnum {
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
  RED = 'RED',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
  PURPLE = 'PURPLE',
  PINK = 'PINK',
  ORANGE = 'ORANGE',
  BROWN = 'BROWN',
  LIGHT_BLUE = 'LIGHT_BLUE',
  CYAN = 'CYAN',
  WHITE = 'WHITE',
  GREY = 'GREY',
}

export enum UIConfig {
  SpecialProjectScanDetail = 'SpecialProjectScanDetail',
  ItemImportDate = 'ItemImportDate',
  ItemQCDate = 'ItemQCDate',
  ItemDeliveredDate = 'ItemDeliveredDate',
  Engineering = 'Engineering',
  MajorProject = 'MajorProject',
  SpecialProject = 'SpecialProject',
  SubcontractorAll = 'SubContractorAll',
  SubcontractorLaserCutting = 'SubContractorLaserCutting',
  SubcontractorInsulation = 'SubContractorInsulationCutting',
  SubcontractorRollForming = 'SubContractorRollForming',
  SubcontractorFolding = 'SubContractorFolding',
  ItemFault = 'ItemFault',
  ProductionFault = 'ProductionFault',
  EngineeringSummary = 'EngineeringSummary',
  FactoryManagement = 'FactoryManagement',
  ProcessQAMajor = 'ProcessQAMajor',
  ProcessQASpecial = 'ProcessQASpecial',
  ProcessTimeMajor = 'ProcessTimeMajor',
  ProcessTimeMajorDetail = 'ProcessTimeMajorDetail',
  ProcessTimeSpecial = 'ProcessTimeSpecial',
  ProcessTimeSpecialDetail = 'ProcessTimeSpecialDetail',
  ProcessTimeMajorItemView = 'ProcessTimeMajorItemView',
  ProcessTimeSpecialItemView = 'ProcessTimeSpecialItemView',
  ProcessTimeActivityLog = 'ProcessTimeActivityLog',
  ProcessTimeProcessLog = 'ProcessTimeProcessLog',
  ProcessTimeProcessLogSummary = 'ProcessTimeProcessLogSummary',
}

export enum ActionKeys {
  Edit = 'edit',
  Delete = 'delete',
  Approve = 'approve',
  Reject = 'reject',
}

export enum AuthorizationMessageKeys {
  PasswordChanged = 'Password_has_been_changed',
  RoleChanged = 'Role_has_been_changed',
  AccountDeactivated = 'Account_has_been_deactivated',
  AccountDeleted = 'Account_has_been_deleted',
  AccountLoggedInOnAnotherDevice = 'Account_has_been_logged_in_on_another_device',
  TokenExpired = 'Token_is_expired',
  SettingChanged = 'Setting_has_been_changed',
  TeamChanged = 'Team_has_been_changed',
  ForceLogout = 'Force_logout_by_admin',
}

export enum ViewLogsEntityType {
  MajorProjectEntity = 'MajorProjectEntity',
  SpecialProjectEntity = 'SpecialProjectEntity',
  SubcontractorEntity = 'SubcontractorEntity',
  FaultEntity = 'FaultEntity',
  JobReleasedSortingEntity = 'JobReleasedSortingEntity',
  ItemEntity = 'ItemEntity',
  ProcessWorkerDefectEntity = 'ProcessWorkerDefectEntity',
  ProcessTimeMajorFile = 'ProcessTimeMajorFile',
  ProcessTimeMajorItemWeb = 'ProcessTimeMajorItemWeb',
  ProcessTimeMajorItemMobile = 'ProcessTimeMajorItemMobile',
  ProcessTimeSpecialFile = 'ProcessTimeSpecialFile',
  ProcessTimeSpecialItemWeb = 'ProcessTimeSpecialItemWeb',
  ProcessTimeSpecialItemMobile = 'ProcessTimeSpecialItemMobile',
  EmployeeAssignment = 'EmployeeAssignment',
  ProcessQAMajor = 'ProcessQAMajor',
  ProcessQASpecial = 'ProcessQASpecial',
}

export enum EngineeringManagementType {
  MajorProjects = 'major-projects',
  SpecialProjects = 'special-projects',
  ItemFault = 'items-fault',
  ProductionFault = 'productions-fault',
  Summary = 'summary',
}

export enum FactoryManagementType {
  JobsSorting = 'jobs-sorting',
  AssignEmployee = 'employee-assignment',
  ProcessLog = 'process-log',
  Summary = 'summary',
}

export enum ProcessTimeItemViewType {
  MajorProject = 'Major',
  SpecialProject = 'Special',
}

export enum MajorProjectStatusEnum {
  Ready = 'Ready',
  InProduction = 'InProduction',
  Exception = 'Exception',
  Delivered = 'Delivered',
  OnHold = 'OnHold',
  Canceled = 'Canceled',
  RequiredBooking = 'RequiredBooking',
  DeliveryBooked = 'DeliveryBooked',
}

export enum SpecialProjectEMStatusEnum {
  Ready = 'Ready',
  InProduction = 'InProduction',
  Exception = 'Exception',
  Completed = 'Completed',
  Locked = 'Locked',
  OnHold = 'OnHold',
  Canceled = 'Canceled',
  RequiredBooking = 'RequiredBooking',
  DeliveryBooked = 'DeliveryBooked',
}

export enum SpecialProjectDrawingColorEnum {
  Blue = 'Blue',
  Gray = 'Gray',
  Red = 'Red',
}

export enum ApprovalStatusEnum {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum RateSettingType {
  ProductionFault = 'ProductionFaultLabourRate',
  LaserCutting = 'LaserCutting',
  InsulationCutting = 'InsulationCutting',
  RollForming = 'RollForming',
  Folding = 'Folding',
  ItemFault = 'ItemFaultLabourRate',
}

export enum ItemManagementType {
  ImportDate = 'import-date',
  QCDate = 'qc-date',
  DeliveredDate = 'delivered-date',
}

export enum FilterType {
  Select = 'Select',
  DatePicker = 'DatePicker',
}

export enum ProcessType {
  Assembly = 'Assembly',
  Capping = 'Capping',
  InsulationFit = 'Insulation Fit',
  Seal = 'Seal',
}

export enum SettingItemType {
  AndroidAppTimeOut = 'AndroidAppTimeOut',
  FactoryJobsDisplaySetting = 'FactoryJobsDisplaySetting',
  DifficultyLevel = 'DifficultyLevel',
  ComponentMatching = 'ComponentMatching',
  LunchTime = 'LunchTime',
  WaitingTime = 'WaitingTime',
  IdlingTime = 'IdlingTime',
  Efficiency = 'Efficiency',
}

export enum AssignEmployeeColumnKey {
  Assembly = 'assembly',
  Capping = 'capping',
  Insulation = 'insulation',
  Seal = 'seal',
  OtherProcess = 'otherProcess',
  Unassigned = 'unassigned',
  NotAvailable = 'notAvailable',
  OnHoliday = 'onHoliday',
}

export enum ProcessQAType {
  Major = 'Major',
  Special = 'Special',
}

export enum ProcessTimeStatusEnum {
  Processed = 'Processed',
  Incomplete = 'Incomplete',
  Pending = 'Pending',
}

export enum ProcessTimeConfigType {
  Settings = 'settings',
  Tables = 'tables',
  DuctTypes = 'duct-types',
}

export enum ProcessTimeLogsType {
  File = 'file',
  ItemWeb = 'item-web',
  ItemMobile = 'item-mobile',
}

export enum ProcessTimeItemType {
  Item = 'Item',
  Part = 'Part',
  Perfmental = 'Perfmental',
  Skin = 'Skin',
  Insulation = 'Insulation',
  FactoryFit = 'Factory Fit',
}

export enum UploadStep {
  UPLOAD_FILE = 0,
  VALIDATED = 1,
  MAPPING_DATA = 2,
  MAPPED_DATA = 3,
}

export enum UploadFileStatus {
  FAIL = 'FAIL',
  Error = 'Error',
  Success = 'SUCCESSFUL',
}
